import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function DiagonalTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden relative" data-testid="resume-live-preview">
      <div className="relative h-28" style={{ backgroundColor: accent }}>
        <div className="absolute inset-0 bg-white" style={{ clipPath: "polygon(0 70%, 100% 40%, 100% 100%, 0 100%)" }} />
        <div className="absolute left-7 top-7">
          <h1 className="text-2xl font-bold text-white">{draft.full_name || "Your Name"}</h1>
          <p className="text-white/85 text-xs mt-0.5 font-semibold">{draft.target_role}</p>
        </div>
      </div>
      <div className="px-7 pb-7 -mt-2">
        <p className="text-slate-500 text-[11px]">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        {draft.summary && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Summary</h2>
            <p className="text-slate-700 mt-1">{draft.summary}</p>
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Skills</h2>
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {draft.skills.map((sk) => <span key={sk} className="text-[11px] font-medium px-2 py-0.5 rounded" style={{ backgroundColor: `${accent}18`, color: accent }}>{sk}</span>)}
            </div>
          </div>
        )}
        {draft.experience.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => (
              <p key={i} className="text-slate-700 mt-1"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school} <span className="text-slate-400 italic">({ed.start_date} - {ed.end_date})</span></p>
            ))}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
